function generateLanguageCodes() {
  const langNames = new Intl.DisplayNames(['en'], { type: 'language' });
  const langMap: Record<string, string> = {};
  for (let i = 0; i < 26; i++) {
    for (let j = 0; j < 26; j++) {
      const code = String.fromCharCode(97 + i) + String.fromCharCode(97 + j);
      const name = langNames.of(code);
      if (name !== code && name !== undefined) {
        langMap[name] = code;
      }
    }
  }
  const langMap2: Record<string, string> = {
    // Avoid using deprecated codes:
    Akan: 'ak',
    Hebrew: 'he',
    Indonesian: 'id',
    Javanese: 'jv',
    Romanian: 'ro',
    Yiddish: 'yi',
    // Optional extras:
    Tagalog: 'tl',
  };
  return { ...langMap, ...langMap2 };
}

// The flag a language is drawn with, which for some is a country rather than the language itself.
const flagOverrides: Record<string, string> = {
  English: 'gb',
  Korean: 'kr',
  Swedish: 'se',
  Latin: 'va',
  Japanese: 'jp',
  Catalan: 'cat', // by default, it's `ca` which conflicts with Canadian French
  Ukrainian: 'ua',
};

const languageCodes = generateLanguageCodes();
const langMap = { ...languageCodes, ...flagOverrides };

export default function (language: string) {
  return langMap[language];
}

// The language's own two-letter code - EN rather than the GB its flag is drawn with.
export const languageCode = (language: string): string | undefined => languageCodes[language];
